import type { Color, HistoryEntry } from '../types';

type Props = {
  entries: HistoryEntry[];
  firstMoveColor?: Color;
  interactive?: boolean;
  onSelect?: (entry: HistoryEntry, index: number) => void;
};

export function MoveHistory({ entries, firstMoveColor = 'w', interactive = false, onSelect }: Props) {
  if (entries.length === 0) {
    return <div className="placeholder">Пока нет ходов</div>;
  }

  const rows: Array<{
    moveNumber: number;
    white?: { entry: HistoryEntry; index: number };
    black?: { entry: HistoryEntry; index: number };
  }> = [];

  entries.forEach((entry, index) => {
    const rowIndex = Math.floor((index + (firstMoveColor === 'b' ? 1 : 0)) / 2);
    const row = rows[rowIndex] || (rows[rowIndex] = { moveNumber: rowIndex + 1 });
    const moveColor = index % 2 === 0
      ? firstMoveColor
      : firstMoveColor === 'w' ? 'b' : 'w';

    if (moveColor === 'w') {
      row.white = { entry, index };
    } else {
      row.black = { entry, index };
    }
  });

  const cell = (item: { entry: HistoryEntry; index: number } | undefined) => {
    if (!item) return <span className="move-cell move-empty">—</span>;

    const content = (
      <>
        <span className="move-san">{item.entry.san}</span>
      </>
    );

    if (!interactive || !onSelect) {
      return <span className="move-cell">{content}</span>;
    }

    return (
      <button
        type="button"
        className="move-cell move-cell-button"
        onClick={() => onSelect(item.entry, item.index)}
      >
        {content}
      </button>
    );
  };

  return (
    <div className="move-history">
      <div className="move-history-head">
        <span>#</span>
        <span>Белые</span>
        <span>Чёрные</span>
      </div>

      {rows.map((row) => (
        <div className="move-history-row" key={row.moveNumber}>
          <span className="move-number">{row.moveNumber}.</span>
          {cell(row.white)}
          {cell(row.black)}
        </div>
      ))}
    </div>
  );
}
